import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useProfileStore = defineStore("profile", {
    state: () => {
        return {
            urls: null,
            datas: null,
            states: null,
            telegramDialogs: false,
            loadings: false
        };
    },

    getters: {
        url: (state) => state.urls,
        data: (state) => state.datas,
        step: (state) => state.states,
        telegramDialog: (state) => state.telegramDialogs,
        loading: (state) => state.loadings,
    },

    actions: {
        get() {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'profile',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.datas = res.data.data
                        resolve(res.data.data.email);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        state() {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'profile/state',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.states = res.data.data.state
                        resolve(res.data.data.state);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject({ code: error.response.data.code, email: error.response.data.data.email });
                    });
            });
        },
        edit(data) {
            this.loadings = true;
            const config = {
                method: "patch",
                url: useRuntimeConfig().public.apiBase + 'profile',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res.data.msg);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject({ code: error.response.data.code, email: error.response.data.data.email });
                    });
            });
        },
        editImage(data) {
            this.loadings = true;
            return new Promise((resolve, reject) => {
                axios.patch(useRuntimeConfig().public.apiBase + 'profile/image', data, {
                    headers: {
                        usertoken: localStorage.token,
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    this.loadings = false
                    this.get()
                    resolve()
                }).catch(() => {
                    this.loadings = false
                    reject()
                })
            });
        },
        getimg() {
            this.loadings = true;
            this.urls = null;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'profile/image',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.urls = res.data
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        logout() {
            this.loadings = true;
            const config = {
                method: "delete",
                url: useRuntimeConfig().public.apiBase + 'profile/logout',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        localStorage.clear()
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
    },
});